import { t } from '@/features/i18n/utils';
import { LEGACY_USER_REVIEW_MAP, UserReview } from '@/features/user-review/constants';

export const normalizeUserReview = (value?: string | null): UserReview => {
  if (!value) return 'NONE';
  return LEGACY_USER_REVIEW_MAP[value] ?? (value as UserReview);
};

export const isIgnoredUserReview = (value?: string | null): boolean => {
  const normalized = normalizeUserReview(value);
  return (
    normalized === 'IGNORED_INCORRECT' ||
    normalized === 'IGNORED_IMMATERIAL' ||
    normalized === 'IGNORED_HANDLED'
  );
};

const USER_REVIEW_SORT_ORDER: Record<UserReview, number> = {
  ACTION_REQUIRED: 4,
  CONFIRMED: 3,
  NONE: 2,
  IGNORED_IMMATERIAL: 1,
  IGNORED_HANDLED: 1,
  IGNORED_INCORRECT: 0,
};

export const getUserReviewSortValue = (userReview?: string | null): number => {
  return USER_REVIEW_SORT_ORDER[normalizeUserReview(userReview)] ?? 0;
};

export const compareByUserReview = (
  a: { userReview: string | null },
  b: { userReview: string | null },
  direction: 'asc' | 'desc' = 'desc',
): number => {
  const aVal = getUserReviewSortValue(a.userReview);
  const bVal = getUserReviewSortValue(b.userReview);
  return direction === 'asc' ? aVal - bVal : bVal - aVal;
};

export type UserReviewOption = { value: UserReview; label: string };

export const getUserReviewOptions = (): UserReviewOption[] => [
  { value: 'NONE', label: t({ en: 'No status', nb: 'Ingen status' }) },
  { value: 'CONFIRMED', label: t({ en: 'Reviewed', nb: 'Gjennomgått' }) },
  { value: 'ACTION_REQUIRED', label: t({ en: 'Action required', nb: 'Handling kreves' }) },
  { value: 'IGNORED_INCORRECT', label: t({ en: 'Incorrect', nb: 'Feil' }) },
  { value: 'IGNORED_IMMATERIAL', label: t({ en: 'Immaterial', nb: 'Uvesentlig' }) },
  {
    value: 'IGNORED_HANDLED',
    label: t({ en: 'Handled elsewhere', nb: 'Håndtert annet sted' }),
  },
];
